/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Drew Burnett
 */

 export const getIsUserOnTeam = (team, userDivisions) => {
    let teamId = team.team_id
    let isUserOnTeam = false
    // Iterate the divisions and the teams
    for (let i = 0; i < userDivisions.length; i++) {
        const division = userDivisions[i]
        for (let j = 0; j < division.myTeams.length; j++) {
            const otherTeam = division.myTeams[j]
            if (otherTeam.team_id === teamId) {
                isUserOnTeam = true
                break
            }
        }
        if (isUserOnTeam) break
    }
    return isUserOnTeam
}